import { render, staticRenderFns } from "./ContactsSection.vue?vue&type=template&id=c62d6826&scoped=true&"
import script from "./ContactsSection.vue?vue&type=script&lang=ts&"
export * from "./ContactsSection.vue?vue&type=script&lang=ts&"
import style0 from "./ContactsSection.vue?vue&type=style&index=0&id=c62d6826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62d6826",
  null
  
)

export default component.exports